<template>
	<div class="fondoModal" v-if="registro !== null">
		<div>
			<div>
				<div class="card">
					<div class="card-header">
						Detalles
						<button type="button" class="close" aria-label="Close" @click="cerrar">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="card-body">
						<div class="row p-0" style="margin-top:-15px;">
							<div class="col-xs-12 col-sm-12 col-md-12-col-lg-4 col-xl-3 pt-2 text-left">
								<div class="text-center">
									<img :src="avatar" style="width:110px;height:110px;" class="rounded-circle">
									<div class="mt-2">
										<h4>{{registro.nombre}} {{registro.apellidos}}</h4>
									</div>
								</div>
								<hr>
								<b>Aparece en las libretas:</b>
								<div class="text-info mt-2" style="font-weight:bold;" v-for="libreta in registro.libretas" :key="libreta.ID_libreta">
									<span class="fa fa-address-book mr-2"></span>
									{{libreta.nombre}}
								</div>
							</div>
							<div class="col-xs-12 col-sm-12 col-md-12-col-lg-8 col-xl-9 bg-light pt-2 pb-2 text-left">
								<div class="card mb-3" v-if="registro.organizaciones.length > 0">
									<div class="card-header bg-info text-white">
										<span class="fa fa-building mr-2"></span>
										Organización
									</div>
									<div class="card-body">
										<div v-for="org in registro.organizaciones" :key="org.ID_organizacion">
											{{org.cargo}} en {{org.nombre}}
										</div>
									</div>
								</div>

								<div class="card mb-3" v-if="registro.telefonos.length > 0">
									<div class="card-header bg-info text-white">
										<span class="fa fa-phone mr-2"></span>
										Teléfonos
									</div>
									<div class="card-body">
										<div v-for="tel in registro.telefonos" :key="tel.ID_telefono" class="mb-2">
											<span class="fa fa-phone mr-2"></span>
											{{tel.telefono}}
										</div>
									</div>
								</div>

								<div class="card mb-3" v-if="registro.emails.length > 0">
									<div class="card-header bg-info text-white">
										<span class="fa fa-envelope mr-2"></span>
										E-mails
									</div>
									<div class="card-body">
										<div v-for="email in registro.emails" :key="email.ID_email" class="mb-2">
											<span class="fa fa-envelope mr-2"></span>
											<a :href="'mailto:' + email.email">{{email.email}}</a>
										</div>
									</div>
								</div>

								<div class="card mb-3" v-if="registro.direcciones.length > 0">
									<div class="card-header bg-info text-white">
										<span class="fa fa-map mr-2"></span>
										Direcciones
									</div>
									<div class="card-body">
										<div v-for="(direccion, index) in registro.direcciones" :key="direccion.ID_direccion" class="mb-4">
											<h3>Dirección #{{(index + 1)}}</h3>
											{{direccion.tipo}}. {{direccion.calle}}, nº {{direccion.numero || 'N/D'}}.
											<br>
											C.P. {{direccion.cp}} - {{direccion.localidad}} {{direccion.provincia}}
											<br>
											<b>{{direccion.comunidad}} ({{direccion.pais}})</b>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!--
					<div class="card-body text-left">
						<pre>{{registro}}</pre>
					</div>
					-->
					<div class="card-footer">
						<button class="btn btn-sm btn-warning" @click="editar()">
							<span class="fa fa-edit mr-2"></span>
							Editar
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import API from '../service'
export default {
	props: ['idregistro'],

	data () {
		return {
			registro: null
		}
	},

	created () {
		API.getRegistro(this.idregistro)
			.then(res => {
				this.registro = res.data.registro
			})
			.catch(e => {
				this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				})
			})
	},

	computed: {
		avatar () {
			if (!this.registro) {
				return '/static/recursos/hombre.svg'
			}

			if (this.registro.avatar) {
				return this.registro.avatar
			}

			if (this.registro.genero === 'mujer') {
				return '/static/recursos/mujer.svg'
			} else {
				return '/static/recursos/hombre.svg'
			}
		}
	},

	methods: {
		cerrar () {
			this.$emit('cerrar')
		},

		editar () {
			this.$emit('editar', this.registro.ID_registro)
		}
	}
}
</script>




// WEBPACK FOOTER //
// src/modulos/libreta-direcciones/vue/contactos/detalles-registro.vue